export default __webpack_public_path__ + "static/media/infoaktivasieztunai.740d0537.svg";